module.exports = __webpack_public_path__ + "img/borrar.a6099a90.png";